import { Injectable, Signal, inject } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { ICurrentUser } from '../interfaces';
import { ApiService } from './api.service';

const CURRENT_USER_ENDPOINT = 'api/v1/admin/me';

@Injectable({ providedIn: 'root' })
export class CurrentUserService {
  private apiService = inject(ApiService);

  private user$!: BehaviorSubject<ICurrentUser>;

  get hasCurrentUser(): boolean {
    return !!this.user$;
  }

  get currentUser$(): Observable<ICurrentUser> {
    return this.user$.asObservable();
  }

  get currentUser(): Signal<ICurrentUser> {
    return toSignal(this.user$.asObservable(), {
      initialValue: this.user$.value,
    });
  }

  fetchCurrentUser$(
    endpoint = CURRENT_USER_ENDPOINT,
  ): Observable<ICurrentUser> {
    return this.apiService
      .get$<ICurrentUser>(endpoint)
      .pipe(tap((user: ICurrentUser) => this.handleUser(user)));
  }

  private handleUser(user: ICurrentUser): void {
    if (!this.user$) {
      this.user$ = new BehaviorSubject(user);
    }
    this.user$.next(user);
  }
}
